<div class="page-padding">

  <mat-card>
    <div class="serch-container" style="margin-top:16px">
      <div class="serch-details-container">
        <span class="panel__header__title">{{'Part Search' | translate | async}}</span>
        <div class="search-details">
          <form class="search-form">

            <mat-form-field class="search-input" style="width: 30% !important" appearance="outline">
              <mat-icon matPrefix style=" color: #d7cfcf; font-size: 20px; ">search</mat-icon>
              <input type="text" placeholder="{{'Make' | translate | async}}" (input)="MakeChanged($event)" matInput [matAutocomplete]="autoMake"
                [(ngModel)]="makeTitle" [ngModelOptions]="{ standalone: true }"
                #autoCompleteInput1="matAutocompleteTrigger" name="Makeauto_">
              <mat-autocomplete [(ngModel)]="makeTitle" #model_auto="ngModel" #autoMake="matAutocomplete"
                (optionSelected)="onSelectMake($event.option)">
                <mat-option [value]="make.Makedesc" *ngFor="let make of filteredMakeViewModel ">
                  {{make.Makedesc }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="search-select-margin" style="width: 30% !important" appearance="outline" >
              <mat-icon matPrefix style=" color: #d7cfcf;font-size: 20px; ">search</mat-icon>
              <input type="text" placeholder="{{'Model' | translate | async}}" (input)="changeModelAutoComplete($event)" matInput
                [matAutocomplete]="auto3" [ngModelOptions]="{ standalone: true }" [(ngModel)]="modelTitle"
                #autoCompleteInput2="matAutocompleteTrigger" name="Modelauto_">
              <mat-autocomplete [(ngModel)]="modelTitle" #model_auto="ngModel" #auto3="matAutocomplete"
                (optionSelected)="onModelSelected($event.option)">
                <!-- <mat-option [value]="0">None</mat-option> -->
                <mat-option [value]="model.Title" *ngFor="let model of filteredModels">
                  {{model.Title}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="model-details-input" style="width: 30% !important" appearance="outline">
              <mat-icon matPrefix style=" color: #d7cfcf;
  font-size: 20px; ">search</mat-icon>
              <input matInput name="serialNumber_" [(ngModel)]="serialNumber" #serialNumber_="ngModel"
                placeholder="{{'Serial Number' | translate | async}}" name="serialNumber">
            </mat-form-field>
          </form>
        </div>
      </div>
    </div>

    <div class="row" style="text-align: right; margin-right: 5px;">
      <button mat-raised-button (click)="resetFields()"> {{'Reset' | translate | async}} </button>
      <button mat-raised-button color="warn" (click)="getChainDetailFiltered()">
        {{'Search' | translate | async}}
        <mat-icon class="btn-icon">search</mat-icon>
      </button>
    </div>
  </mat-card>
  <mat-card style="margin-top: 20px; margin-bottom: 20px;" *ngIf="UserQuoteHistory.length>0">
    <div class="row">

      <div class="panel panel--inspections" style="margin-left:15px;">

        <div class="panel__content flex flex--align-stretch" style="overflow-x: auto;     justify-content: start;">
          <div style="margin-right: 20px;">
            <span class="panel__header__title">{{'History' | translate | async}}</span>
          </div>
          <div *ngFor="let inspection of UserQuoteHistory;">
            <div class="square-button"
              (click)="loadChainActivePartQuoteInfo(inspection.ChainId,inspection.PartQuoteId,1,inspection.ModelId,inspection.HistoryDate)">
              <span style="font-size: medium;font-weight: 500;">{{'DNET Cost' | translate | async}} : {{inspection.TotalCost | currency:'USD':'symbol':'1.0-0'}}</span>
              <span style="font-size: medium;font-weight: 500; padding-top: 2px;padding-bottom: 2px">{{inspection.ChainDescription }}</span>
              <span style="margin-top: 10px;">{{inspection.HistoryDate | date: 'dd/MM/yyyy'}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
  <mat-card class="col-lg-12" style="padding: 20px; margin-top: 20px;" *ngIf="searchDiv">
    <div class="row">
      <div class="col-lg-6">
        <span class="panel__header__title">{{'Search Result' | translate | async}}</span>
      </div>
      <div class="col-lg-6" style="text-align: right;">
        <button type="button" mat-raised-button color="warn" (click)="requestANewModelPopup()">{{'Request New Chain' | translate | async}}</button>
      </div>
    </div>
    <div *ngIf="!tableDataLoading" class="search-result-table-container mat-elevation-z8">

      <mat-table #table [dataSource]="dataSource">
        <ng-container matColumnDef="ChainDesc">
          <mat-header-cell *matHeaderCellDef> {{'Chain Des' | translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.ChainDescription}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ModelSerialNumberStart">
          <mat-header-cell *matHeaderCellDef> {{'Serial Number Start' | translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.ModelSerialNumberStart}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ModelSerialNumberEnd">
          <mat-header-cell *matHeaderCellDef> {{'Serial Number End' | translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.ModelSerialNumberEnd}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Pitch">
          <mat-header-cell *matHeaderCellDef> {{'Pitch' | translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.Pitch}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="NumberOfLinks">
          <mat-header-cell *matHeaderCellDef> {{'# Of Links' | translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.NumberOfLinks}} </mat-cell>
        </ng-container>



        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns; " [ngClass]="{ 'selected': row === selectRow }"
          (click)="selectRow(row)"></mat-row>
      </mat-table>
      <div *ngIf="dataSource.data.length === 0" class="no-data">{{'No data available' | translate | async}}!</div>

    </div>
    <mat-spinner class="loading-spinner" *ngIf="tableDataLoading"></mat-spinner>
  </mat-card>



  <mat-card *ngIf="newRow" class="mt-5">



    <div class="search-result-table-container mat-elevation-z8">
      <div class="row" style="padding: 30px;">
        <div class="col-lg-6">
          <span class="panel__header__title">{{'Part Required' | translate | async}}</span>
        </div>
        <div class="col-lg-6" style="text-align: right;">
          <!-- <button type="button" mat-raised-button color="warn" (click)="popUpBilling()">Add Billing Detail</button> -->
        </div>
      </div>

      <div class="row" style="padding-right: 30px;">

        <!-- <div class="col-lg-12" style="text-align: right;">
          <h3>Status: <span *ngIf="HavingQuote;else NotSaved" class="warn">Saved</span>
            <ng-template #NotSaved>In progress</ng-template>
          </h3>
        </div> -->
      </div>
      <mat-table #table [dataSource]="dataSource_">

        <ng-container matColumnDef="PartNo">
          <mat-header-cell *matHeaderCellDef> {{'Part No' | translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.PartNumber}} </mat-cell>
        </ng-container>


        <ng-container matColumnDef="comparttype">
          <mat-header-cell *matHeaderCellDef> {{'Component Type' | translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.CompartType}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="desc">
          <mat-header-cell *matHeaderCellDef> {{'Component Description' | translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.PartDescription}} </mat-cell>
        </ng-container>


        <ng-container matColumnDef="partline">
          <mat-header-cell *matHeaderCellDef> {{'PartLine' | translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.PartLine}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="qauantityRequired">
          <mat-header-cell *matHeaderCellDef> {{'Quantity Required' | translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element">
           
            <mat-form-field class="model-details-input"  style="width: 30% !important">
              <input type="number" matInput name="quantity" [(ngModel)]="element.QuantityReq" #quantity="ngModel"
                id="compart{{element.CompartId}}" name="quantity"
                (change)="onQuantityChange(element.CompartId,element.QuantityReq,element.Quantity)">
            </mat-form-field>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="qtyinstock">
          <mat-header-cell *matHeaderCellDef> {{'Quantity in Stock' | translate | async}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.Quantity}} </mat-cell>
        </ng-container>
       
        <ng-container matColumnDef="costeach">
          <mat-header-cell *matHeaderCellDef>{{'DNET  Cost Each' | translate | async}}</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.Cost | currency:'USD':'symbol':'1.0-0'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="costtotal">
          <mat-header-cell *matHeaderCellDef>{{'DNET  Cost Total' | translate | async}}</mat-header-cell>
          <mat-cell *matCellDef="let element"><span *ngIf="element.CostTotal!=null;">{{element.CostTotal | currency:'USD':'symbol':'1.0-0'}}</span>


          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="addQuote">
          <mat-header-cell *matHeaderCellDef>{{'Add to Part List' | translate | async}}</mat-header-cell>
          <mat-cell *matCellDef="let element">
           
              <mat-checkbox class="example-margin" [(ngModel)]="element.AddToQuote"></mat-checkbox>
            
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns_"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns_; "
          [ngClass]="{ 'selected': row === selectedRow }"></mat-row>
      </mat-table>
      <div class="row">
        <div class="col-lg-12" style="text-align: right;padding: 30px;">

          <button mat-raised-button *ngIf="!isHistoryClick" color="warn" (click)="SaveQuoteDetails()">
            <span *ngIf="!HavingQuote ">{{'Save' | translate | async}}</span>
            <span *ngIf="HavingQuote">{{'Update' | translate | async}}</span>
          </button>

          <button mat-raised-button *ngIf="isHistoryClick" color="warn" (click)="SaveQuoteDetails()">
            {{'Save' | translate | async}}
          </button>
        </div>

      </div>


    </div>
    <div *ngIf="dataSource_.data.length == 0" class="no-data">{{'No data available' | translate | async}}!</div>
    <mat-spinner class="loading-spinner" *ngIf="tableDataLoadingComponent"></mat-spinner>

    <div class="request-quote-card">
      <mat-card>
        <mat-card-content>
          <div class="request-quote-header">
            <span class="panel__header__title">{{'Request Part List' | translate | async}}</span>
          </div>
          <div class="request-quote-form">
            <mat-form-field class="comments-field" appearance="outline" color="warn">
              <mat-label>{{'Comments' | translate | async}}</mat-label>
              <textarea matInput rows="3" [(ngModel)]="quoteComment"></textarea>
            </mat-form-field>

            <!-- <div class="send-to-section">
              <mat-form-field class="header-form-full-width">
                <span class="label">Email</span>
                <mat-select id="select-Dealer" placeholder="Select Email" [(ngModel)]="dealerGroupId">
                  <mat-option [value]="-1" [disabled]>
                    Select Dealer Email
                  </mat-option>
                  <mat-option [value]="item.Id" *ngFor="let item of userDealerGroup">
                    {{item.Email}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div> -->

            <div class="action-buttons">
              <button mat-raised-button (click)="DownLoadPartsQuote()">
                <mat-icon matPrefix >download</mat-icon> {{'Parts' | translate | async}}

              </button>
              <div *ngIf='partQuoteId>0 ;else Emaildisabled'>
                <button mat-raised-button color="warn" (click)="EmailSend()">
                  {{'Send Email' | translate | async}}
                </button>
               
              </div>
              <ng-template #Emaildisabled>
                <button mat-raised-button disabled>
                  {{'Send Email' | translate | async}}
                </button>
              </ng-template>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-card>
</div>